import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { targetActions } from '../slices/target.slice';
import { ITargetPayload, IFinderMessagePayload } from '../../types/@target';
import { fetchTarget, sendFinderMessage } from '../../services/target.service';
import { notificationActions } from '../slices/notification.slice';

function* getTarget({ payload }: PayloadAction<ITargetPayload>) {
  try {
    const fetchResult: string = yield call(fetchTarget, payload.id);
    yield put({ type: targetActions['getTarget/ok'].type, payload: fetchResult });
  } catch (err) {
    yield put({ type: targetActions['getTarget/err'].type, payload: err });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

function* postFinderMessage({ payload }: PayloadAction<IFinderMessagePayload>) {
  try {
    yield call(sendFinderMessage, payload);
    yield put({ type: targetActions['sendFinderMessage/ok'].type });
    yield put({ type: notificationActions.success.type, payload: 'Message sent to owner' });
  } catch (err) {
    yield put({ type: targetActions['sendFinderMessage/err'].type, payload: err });
    yield put({ type: notificationActions.error.type, payload: err });
  }
}

export function* watchTarget() {
  yield takeLatest(targetActions.getTarget, getTarget);
  yield takeLatest(targetActions.sendFinderMessage, postFinderMessage);
}